import './styles.scss';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';

const MobileSocialBlock = () => {
    const { footer_instagram_link, footer_facebook_link, footer_youtube_link } = useSelector(selectTranslations);
    return (
        <div className="social-media-section">
            <p>We're on social media</p>
            <div className="social-media-wrapper">
                {footer_instagram_link && <a target="_blank" rel="noreferrer" href={footer_instagram_link} className="button instagram" />}
                {footer_facebook_link && <a target="_blank" rel="noreferrer" href={footer_facebook_link} className="button facebook" />}
                {footer_youtube_link && <a target="_blank" rel="noreferrer" href={footer_youtube_link} className="button youtube" />}
            </div>
        </div>
    );
};
export default MobileSocialBlock;
